module.exports = __webpack_public_path__ + "1c517ad28803801122de51036778a439.webm";